<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-document-create-or-update v-model="document" :errors="errors"></employee-document-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="employee-document"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import DocumentOperationsApi from '@/api/document-operations'
import EmployeeDocumentCreateOrUpdate from './components/EmployeeDocumentCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        EmployeeDocumentCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            document:{
                Id:0,
                Name:null
            },
            fields:[
                { name:"Doküman Adı",key:"Name", thClass:"w-100",sortable:true,}
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.document.Id = 0
            this.document.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.document.Id = item.Id
            this.document.Name = item.Name
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            DocumentOperationsApi.EmployeeDocument.CreateOrUpdate(this.editing,this.document)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        provider(data){
            return DocumentOperationsApi.EmployeeDocument.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} görevini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    DocumentOperationsApi.EmployeeDocument.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>